/* eslint-disable perfectionist/sort-enums */
export enum Routes {
  // Public routes
  ACCEPT_CONSENTS = '/accept-consents',
  NOT_FOUND = '/page-not-found',
  IMPERSONATE = '/impersonate',
  CALLBACK = '/callback',
  ERROR = '/error',
  WILDCARD = '*',
  ROOT = '/',

  // Company routes
  COMPANY_ID = '/:companyId',
  EMPLOYEE_PROFILES = 'employee-profiles',
  EMPLOYEE_PROFILE = 'employee-profiles/:profileId',
  PARKING_SPOTS = 'parking-spots',
  FILES_REPORTS = 'files-reports',
  TRANSACTION_HISTORY = 'transaction-history',
  INVOICING = 'invoicing',
  REPORTS = 'reports',
  NOTIFICATIONS = 'notifications',
  SUBSCRIPTION = 'subscription',
  COST_CENTER = 'cost-center',
  EMPLOYEES = 'employees',
  VEHICLES = 'vehicles',
  DASHBOARD = 'home',
  USERS = 'users',
  HELP = 'help',

  // Onboarding routes
  ONBOARDING = '/onboarding',
  ADD_VEHICLES = 'add-vehicles',
  ADD_EMPLOYEES = 'add-employees',
  IMPORT_SUMMARY = 'import-summary',
  IMPORT_REMOVAL = 'import-removal',
  IMPORT_VEHICLES = 'import-vehicles',
  IMPORT_EMPLOYEES = 'import-employees',
  TOP_UP_BALANCE = 'top-up-balance',
  TOP_UP_BALANCE_SUCCESS = 'top-up-balance-success',
  TOP_UP_BALANCE_FAILED = 'top-up-balance-failed',
  SUBSCRIPTIONS = 'subscriptions',
  COMPANY_POLICY = 'company-policy',
  FINISH = 'finish',
}
